import { FinalExecutionOutcome } from "@near-wallet-selector/core";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { t } from "i18next";

import { contractId } from "services/config";
import PreStakingContract from "services/contracts/PreStakingContract";
import RPCProviderService from "services/RPCProviderService";
import ToastService from "shared/components/Toast";
import { ZERO } from "shared/constants";
import { ITransaction } from "shared/interfaces";
import { BigNumber } from "shared/utils/calculations";
import { RootState } from "store";

import { updateState } from "./updateState";

export const claim = createAsyncThunk<
  void,
  {
    provider: RPCProviderService;
    requestSignTransactions: (transaction: ITransaction[]) => Promise<void | FinalExecutionOutcome[]>;
  },
  { state: RootState }
>("preStaking/claim", async ({ provider, requestSignTransactions }, { getState, dispatch }) => {
  try {
    const { preStaking } = getState();

    const claimAvailable = Object.values(preStaking.userData).some((balance) => BigNumber(balance).gt(ZERO));

    if (!claimAvailable) return;

    const preStakingContract = new PreStakingContract({ provider, contractId });
    const transaction = await preStakingContract.createClaimTransaction();
    if (!transaction) return;

    const result = await requestSignTransactions([transaction]);

    if (result) dispatch(updateState({ provider: provider, contractId }));
  } catch (error) {
    ToastService.error({ text: t("toast.error.claim") });
    console.error("Error during tokens claim: ", error);
  }
});
